function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Combined Shape");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Player/02---1820",
  transform: "translate(-270.000000, -213.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "Player/3"
}, React.createElement("g", {
  id: "Group-6",
  transform: "translate(32.000000, 157.000000)"
}, React.createElement("path", {
  d: "M240.17682,56.5771972 L245.061701,59.8352358 C245.704953,60.2642615 245.878618,61.1335143 245.449592,61.7767663 C245.347139,61.9303772 245.215312,62.0622043 245.061701,62.1646572 L240.17682,65.4226957 C239.533568,65.8517214 238.664315,65.6780568 238.235289,65.0348048 C238.081871,64.8047802 238,64.5344781 238,64.257985 L238,57.741908 C238,56.9687093 238.626801,56.341908 239.4,56.341908 C239.676493,56.341908 239.946795,56.4237792 240.17682,56.5771972 Z M248,56 C248.552285,56 249,56.4477153 249,57 L249,65 C249,65.5522847 248.552285,66 248,66 C247.447715,66 247,65.5522847 247,65 L247,57 C247,56.4477153 247.447715,56 248,56 Z",
  id: "Combined-Shape"
})))));

var SvgNext = function SvgNext(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "11px",
    height: "10px",
    viewBox: "0 0 11 10",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNext, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/next.473ca824.svg";
export { ForwardRef as ReactComponent };